import React, { useCallback, useMemo } from 'react';

import {
    EnhancedPanelSkeleton,
    PdfViewer,
    SkeletonLoader,
} from '@europrocurement/flexy-components';
import { MediaObject, useAchatsService } from '@europrocurement/l2d-domain';
import { Card, SxProps } from '@mui/material';
import { useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { useLoadingStatus } from '@europrocurement/l2d-hooks';
import { AppDispatch } from '../../../../redux/types';

export type MediaObjectReaderType = {
    mediaObject?: MediaObject;
    sx?: SxProps;
};

export const MediaObjectReader = function ({ mediaObject, sx }: MediaObjectReaderType) {
    const { mediaobjectid } = useParams();
    const dispatch = useDispatch<AppDispatch>();

    const { selectMediaobject } = useAchatsService();

    const fetchCurrentMediaObjectPage = useMemo<number>(() => {
        if (!mediaObject) {
            console.error('Missing media object to fetch page !');
            if (mediaobjectid) {
                console.warn('Force select media object from URL params');
                dispatch(selectMediaobject({ id: mediaobjectid }));
            }
        }

        const mediaObjectReaderParam = localStorage.getItem('mediaObjectReaderParam');
        let fetchedPage = 1;

        if (mediaObjectReaderParam && mediaObject?.id === JSON.parse(mediaObjectReaderParam).id) {
            fetchedPage = JSON.parse(mediaObjectReaderParam).currentPage;
        }

        return fetchedPage;
    }, [dispatch, mediaObject, mediaobjectid, selectMediaobject]);

    const loadData = useCallback(() => !!mediaObject, [mediaObject]);

    const { loading } = useLoadingStatus({
        checkReady: loadData,
    });

    return (
        <SkeletonLoader
            isLoading={loading}
            skeleton={<EnhancedPanelSkeleton skeletonMode="enhanced" />}
        >
            <Card
                id="cardPdfReader"
                sx={{ ...sx }}
            >
                <PdfViewer
                    title={mediaObject?.originalName}
                    pdfUrl={mediaObject?.contentUrl ?? undefined}
                    defaultPage={fetchCurrentMediaObjectPage}
                    onPageChange={(page) => {
                        localStorage.setItem(
                            'mediaObjectReaderParam',
                            JSON.stringify({
                                id: mediaObject?.id,
                                currentPage: page,
                            }),
                        );
                    }}
                />
            </Card>
        </SkeletonLoader>
    );
};

export default MediaObjectReader;
